<template>
    <div class="item-table">
        <div class="item-table-header">
            <strong>{{ item.Title }}</strong>
            <TruncateText v-if="item.Description" :text="item.Description" :rows="1" />
        </div>
        <CancellationTable :rows="rows" />
    </div>
</template>

<script lang="ts">
    import { defineComponent, computed, PropType } from 'vue';
    import { CartCancellationItem } from './CartCancellation.interfaces';
    import { CancellationTableRow } from '@ui/components/CancellationTable/CancellationTable.interfaces';
    import { convertToDate } from '@shared/helpers/datetime/datetime';
    import { t } from '@shared/helpers/translation';
    import { getLocaleDayShortMonthTime } from '@shared/helpers/datetime/datetime.formatters';
    import CancellationTable from '@ui/components/CancellationTable/CancellationTable.vue';
    import TruncateText from '@ui/components/TruncateText/TruncateText.vue';

    export default defineComponent({
        name: 'CartCancellation',
        methods: { t },
        components: {
            CancellationTable,
            TruncateText,
        },
        props: {
            item: {
                type: Object as PropType<CartCancellationItem>,
                required: true,
            },
        },
        setup({ item }) {
            const rows = computed<CancellationTableRow[]>(() =>
                item.Policies.map((x) => {
                    const label = `${t({ key: 'shared.after' })} ${getLocaleDayShortMonthTime(convertToDate(x.FromDate))}`;

                    return {
                        label,
                        cost: x.Amount,
                        active: x.Active,
                        refundable: x.Refundable,
                    };
                })
            );

            return {
                rows,
            };
        },
    });
</script>

<style lang="scss" scoped>
    @forward '../Cancellation.scss';
</style>
